import { FC, JSX } from "react";
import { LoginForm } from "@/features/auth/components/LoginForm/LoginForm";
import AuthLayout from "@/features/auth/components/AuthLayout/AuthLayout";
import { Flex, Heading, Text } from "@radix-ui/themes";
import { Link } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutes";
import AuthImage from "@/features/auth/components/AuthImage/AuthImage";
import SecondImage from "@/assets/Dreamhack-61.jpg";

const Login: FC = (): JSX.Element => {
  return (
    <AuthLayout>
      <Flex gap="5" direction="column" justify="center">
        <Flex gap="2" direction="column">
          <Heading mb="0" as="h1" size="8">
            Log in
          </Heading>
          <Text size="3" color="gray">
            Dive back into the world of events and opportunities. Log in to your
            account to continue your job search.
          </Text>
        </Flex>
        <LoginForm />
        <Flex gap="1" justify="center">
          <Text size="2" color="gray">
            Don't have an account?{" "}
          </Text>
          <Text size="2">
            <Link to={siteRoutes.auth.register.path}>
              {siteRoutes.auth.register.label}
            </Link>
          </Text>
        </Flex>
      </Flex>
      <AuthImage image={SecondImage} />
    </AuthLayout>
  );
};

export default Login;
